import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-forecast-legend',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './forecast-legend.component.html',
  styleUrls: ['./forecast-legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForecastLegendComponent {}
